import React from "react";
import { Link } from "react-router-dom";
import { productsData } from "../data/productsData";
import ProductCard from "../components/ProductCard";
import SEO from "../components/SEO";
import { serviceSchema, generateBreadcrumbSchema } from "../utils/schemaMarkup";

const Products = () => {
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: "Home", url: "https://www.ceekayenterprise.com/" },
    { name: "Products", url: "https://www.ceekayenterprise.com/products" },
  ]);

  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [serviceSchema, breadcrumbSchema],
  };

  return (
    <div className="page active">
      <SEO
        title="Industrial Chemicals Products | Borates, Sulfates, Nitrates & Specialty Chemicals | Ceekay Enterprise"
        description="Browse our comprehensive catalog of industrial chemicals including borates (sodium tetraborate pentahydrate), sulfates, nitrates, oxides, and specialty chemicals. High purity grades for construction, textiles, agriculture, manufacturing, and water treatment. Request quotes for bulk orders."
        keywords="industrial chemicals catalog, borates supplier, sodium tetraborate pentahydrate, boric acid, calcium chloride, potassium bicarbonate, ammonium molybdate, magnesium oxide, chemical products India, bulk chemicals supplier"
        canonical="https://www.ceekayenterprise.com/products"
        schema={combinedSchema}
      />
      
      {/* Breadcrumb */}
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Products</span>
      </nav>

      <div className="products-header">
        <h1 className="page-title">Our Products</h1>
        <p className="products-intro">
          Discover our wide range of high-quality industrial chemicals and specialty products. 
          We import and supply premium-grade chemicals suitable for various industrial applications 
          including construction, textiles, agriculture, manufacturing, and water treatment.
        </p>
      </div>
      <div className="product-grid">
        {productsData.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      <div className="products-cta">
        <h3>Looking for a specific chemical?</h3>
        <p>Contact us for custom requirements, bulk pricing, and technical specifications.</p>
        <Link to="/contact" className="primary-cta">
          <span>Request Quote</span>
          <div className="cta-arrow">→</div>
        </Link>
      </div>
    </div>
  );
};

export default Products;
